import { render, staticRenderFns } from "./ConfigSchemaForm.vue?vue&type=template&id=e12436b6"
import script from "./ConfigSchemaForm.vue?vue&type=script&lang=js"
export * from "./ConfigSchemaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports